import React, { useEffect, useState } from "react";

import { horseService } from "../../api/horses.service";
import Modal from "../elements/Modal";
import TreeItem from "../elements/TreeItem";

function mapAncestry(response) {
	return (response?.ancestry || []).reduce((ancestry, item) => ({
		...ancestry,
		[item.position]: item.ancestry_horse,
	}), {});
}

function FamilyModal({ isOpenModels, setIsOpenModels, dataLot }) {
	const [sireAncestry, setSireAncestry] = useState({});
	const [damAncestry, setDamAncestry] = useState({});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let cancelled = false;
		setSireAncestry({});
		setDamAncestry({});
		if (!dataLot || !isOpenModels) return undefined;

		setLoading(true);
		const sireRequest = dataLot.sire?.id
			? horseService.ancestry(dataLot.sire.id, "horse_sire")
			: Promise.resolve({ ancestry: [] });
		const damRequest = dataLot.dam?.id
			? horseService.ancestry(dataLot.dam.id, "horse_dam")
			: Promise.resolve({ ancestry: [] });

		Promise.all([sireRequest, damRequest])
			.then(([sireResponse, damResponse]) => {
				if (cancelled) return;
				setSireAncestry(mapAncestry(sireResponse));
				setDamAncestry(mapAncestry(damResponse));
			})
			.catch(() => {
				if (!cancelled) {
					setSireAncestry({});
					setDamAncestry({});
				}
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [dataLot, isOpenModels]);

	if (!isOpenModels) return null;

	return (
		<Modal isOpen={isOpenModels} className="catalogue-family-modal-container" fullScreen>
			<section className="catalogue-family-modal" role="dialog" aria-modal="true" aria-labelledby="catalogue-family-title">
				<header className="catalogue-family-modal__header">
					<div>
						<p>Lot {dataLot?.lot || "family"}</p>
						<h2 id="catalogue-family-title">Family overview</h2>
						<span>{dataLot?.sire?.display_name || "Unknown sire"} × {dataLot?.dam?.display_name || "Unknown dam"}</span>
					</div>
					<button type="button" onClick={() => setIsOpenModels(false)} aria-label="Close family overview">
						<i className="fa fa-times" aria-hidden="true" />
					</button>
				</header>

				<div className="catalogue-family-modal__body">
					{loading ? (
						<div className="catalogue-family-modal__loading" role="status">
							<span className="catalogue-library__spinner" />
							Loading family tree…
						</div>
					) : (
						<div className="catalogue-family-modal__viewport">
							<div className="tree catalogue-family-tree flexer flexer-nowrap">
								<div className="tree__col" col="1">
									<div className="tree__row flexer flexer-vcenter"><TreeItem type="sire" value={dataLot?.sire?.display_name || "No sire"} /></div>
									<div className="tree__row flexer flexer-vcenter"><TreeItem type="dam" value={dataLot?.dam?.display_name || "No dam"} /></div>
								</div>

								<div className="tree__col" col="2">
									{[3, 4].map((position) => <div key={`sire-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="sire" value={sireAncestry[position]?.display_name || ""} /></div>)}
									{[5, 6].map((position) => <div key={`dam-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="dam" value={damAncestry[position]?.display_name || ""} /></div>)}
								</div>

								<div className="tree__col" col="3">
									{[7, 8, 9, 10].map((position) => <div key={`sire-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="sire" value={sireAncestry[position]?.display_name || ""} /></div>)}
									{[11, 12, 13, 14].map((position) => <div key={`dam-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="dam" value={damAncestry[position]?.display_name || ""} /></div>)}
								</div>

								<div className="tree__col" col="4">
									{Array.from({ length: 8 }, (_, index) => index + 15).map((position) => <div key={`sire-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="sire" value={sireAncestry[position]?.display_name || ""} /></div>)}
									{Array.from({ length: 8 }, (_, index) => index + 23).map((position) => <div key={`dam-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="dam" value={damAncestry[position]?.display_name || ""} /></div>)}
								</div>

								<div className="tree__col" col="5">
									{Array.from({ length: 16 }, (_, index) => index + 31).map((position) => <div key={`sire-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="sire" value={sireAncestry[position]?.display_name || ""} /></div>)}
									{Array.from({ length: 16 }, (_, index) => index + 47).map((position) => <div key={`dam-${position}`} className="tree__row flexer flexer-vcenter"><TreeItem type="dam" value={damAncestry[position]?.display_name || ""} /></div>)}
								</div>
							</div>
						</div>
					)}
				</div>
			</section>
		</Modal>
	);
}

export default FamilyModal;
